import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { MessageParameterChart } from '@model/webFeeder/message-parameter-chart.model';
import { MessageWebFeeder } from '@model/webFeeder/message-web-feeder.model';
import { ConfigService } from '@services/webFeeder/config.service';
import { SocketService } from '@services/webFeeder/socket.service';
import { map, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChartService {
  public messagesChart: Observable<any>;
  private serviceSubject = new Subject<MessageEvent>();
  private uniqueChartID = 0;
  private canSubscribe = true;
  private canUnsubscribe = true;
  private symbolsRegistered: string[] = [];
  private subscribeException = false;
  private loadingResolution = false;
  private firstSymbolException = false;
  constructor(
    private socketService: SocketService,
    private configService: ConfigService,
    public datepipe: DatePipe
  ) {
  }
  getNewChartId() {
    this.uniqueChartID++;
    return this.uniqueChartID;
  }

  getRegisteredSymbolsInterval(newSymbol: string, period: string) {
    newSymbol = newSymbol.trim().replace(' ', '').toLowerCase();
    const symbol_period = newSymbol + '_' + period;
    const symbol = this.symbolsRegistered.filter(item => item === symbol_period);
    if (symbol.length > 0) {
      return this.symbolsRegistered;
    } else {
      return null;
    }
  }

  getRegisteredSymbols(newSymbol) {
    newSymbol = newSymbol.trim().replace(' ', '').toLowerCase();
    const symbol = this.symbolsRegistered.filter(item => item.split('_')[0] === newSymbol);
    if (symbol.length > 0) {
      return this.symbolsRegistered;
    } else {
      return null;
    }
  }

  subscriptionExcpetion() {
    this.subscribeException = true;
  }

  setLoadingResolution() {
    this.loadingResolution = true;
  }

  setFirstSymbolException() {
    this.firstSymbolException = true;
  }

  createSubject() {
    const newService = {
      name: 'ChartSvcByFn',
      serviceSubject: this.serviceSubject,
      fn: (data) => data && data.response_type && data.response_type.toString().toLowerCase() === 'gch'
    };
    this.socketService.register(newService);
    this.messagesChart = newService.serviceSubject.pipe(map(data => {
      return data;
    }));
  }

  subscribeChart(symbol: string, period: string, iniDate: string) {
    setTimeout(() => {
      if ((!this.subscribeException || !this.getRegisteredSymbolsInterval(symbol, period)) && !this.loadingResolution && !this.firstSymbolException) {
        this.subscribeException = false;
        if (this.canSubscribe) {
          this.canSubscribe = false;
          this.canUnsubscribe = false;
          setTimeout(() => {
            if (symbol !== '' && symbol !== undefined && !this.getRegisteredSymbolsInterval(symbol, period)) {
              symbol = symbol.trim().replace(' ', '').toLowerCase();
              const symbol_period = symbol + '_' + period;
              this.symbolsRegistered.push(symbol_period);
              this.configService.writeLog('SUBSCRIBE CHART > [' + symbol + '] , period > [' + period + '] <<<<<');
              this.sendMessageChart(symbol, period, 'true', iniDate);
              this.canSubscribe = true;
              this.canUnsubscribe = true;
            } else if (symbol !== '' && symbol !== undefined) {
              this.unsubscribeChart(symbol, period);
            }
          }, 1000);
        } else {
          setTimeout(() => { this.subscribeChart(symbol, period, iniDate); }, 100);
        }
      }
      this.firstSymbolException = false;
      this.subscribeException = false;
      this.loadingResolution = false;
    }, 100)

  }

  unsubscribeChart(symbol: string, period: string) {
    if (this.canUnsubscribe) {
      if (symbol !== '' && symbol !== undefined && this.getRegisteredSymbolsInterval(symbol, period) !== null) {
        this.canSubscribe = false;
        this.canUnsubscribe = false;
        symbol = symbol.trim().replace(' ', '').toLowerCase();
        const symbol_period = symbol + '_' + period;
        this.symbolsRegistered = this.symbolsRegistered.filter(item => item !== symbol_period);

        setTimeout(() => {
          this.sendMessageChart(symbol, period, 'false', null);
          this.configService.writeLog('UNSUBSCRIBE CHART > [' + symbol + '] , period > [' + period + '] <<<<<');

          this.canSubscribe = true;
          this.canUnsubscribe = true;
        }, 1000);
      }
    } else {
      setTimeout(() => { this.unsubscribeChart(symbol, period); }, 100);
    }
  }

  private sendMessageChart(symbol: string, period: string, dispatch: string, iniDate: string) {
    if (!period) {
      period = '5';
    }
    let today = new Date();
    switch (period) {
      case 'D': {
        today = new Date(new Date().setDate(new Date().getDate() - 2));
        iniDate = this.datepipe.transform(today, 'yyyyMMdd');
        break;
      }
      case 'W': {
        today = new Date(new Date().setDate(new Date().getDate() - 8));
        iniDate = this.datepipe.transform(today, 'yyyyMMdd');
        break;
      }
      case 'M': {
        today = new Date(new Date().setDate(new Date().getDate() - 31));
        iniDate = this.datepipe.transform(today, 'yyyyMMdd');
        break;
      }
      default: {
        iniDate = null;
      }
    }
    const dataMsg: MessageWebFeeder = new MessageWebFeeder();
    dataMsg.token = this.configService.getToken();
    dataMsg.module = 'chart';
    dataMsg.service = 'candleChart';
    const messageParameter = new MessageParameterChart();
    messageParameter.quote = symbol.toLowerCase();
    messageParameter.period = period;
    messageParameter.realTime = 'true';
    messageParameter.quantity = '2';
    messageParameter.dispatch = dispatch;
    messageParameter.initDate = iniDate;
    dataMsg.parameters = messageParameter;
    setTimeout(() => {
      this.socketService.signService(dataMsg);
    }, 1000);
  }
}
